import React, { useState, useEffect, useRef } from "react";
import okcopy from "../img/okcopy.png";
import "../styles/Faq.scss";
import Api from "../common/api";


const Faq = () => {
  const [tabs, setTabs] = useState([]);
  const lang = localStorage.getItem("lang");

  React.useEffect(() => {
    Api.get("/faqs/list/").then((res) => {
      setTabs(res.data.items)
      // setCurrentTab(res.data.items[res.data.items.findIndex(x => x.Link == activePath)])
    });
  }, []);

  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [currentTabId, setCurrentTabId] = useState(null);
  const [isActive, setisActive] = useState(false);

  let myRef = useRef()

  const tabClickHandler = (id, sort) => {
    window.scrollTo({ behavior: 'smooth', top: myRef.current.offsetTop - 850 })
    setCurrentTabId(id);
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    if (id == currentTabId) {
      setCurrentTabId(null);
    } else {
      setCurrentTabId(id);
    }
  };

  return tabs
    ? tabs.map((tab) => {
      return (
        <div key={tab.id} className="answer-question">
          
          {lang == "en"?(
          <>
          <div  style={{ cursor: 'pointer' }} ref={myRef} onClick={() => (tabClickHandler(tab.id, tab.sort))} className={currentTabId === tab.id ? "question-part active" : "question-part"}>           
            <h4>{tab.Title_EN}</h4>
            <img
              className={currentTabId === tab.id ? "rotate" : "flat"}
              src={okcopy}
              alt="ss"
            />
          </div>
          <div className={currentTabId === tab.id ? "show active" : "show"}
            dangerouslySetInnerHTML={{
              __html: tab.Description_EN,
            }}
          >
          </div>
          </>
          ):( <>
            <div  style={{ cursor: 'pointer' }} ref={myRef} onClick={() => (tabClickHandler(tab.id, tab.sort))} className={currentTabId === tab.id ? "question-part active" : "question-part"}>           
              <h4>{tab.Title}</h4>
              <img
                className={currentTabId === tab.id ? "rotate" : "flat"}
                src={okcopy}
                alt="ss"
              />
            </div>
            <div className={currentTabId === tab.id ? "show active" : "show"}
              dangerouslySetInnerHTML={{
                __html: tab.Description,
              }}
            >
            </div>
            </>)}

        </div>
      );
    })
    : null;
};

export default Faq;
